<template>
    <div class="components-login-history">
        <p class="paddingB15">
            <span class="fontBold">登录历史</span>
            <span class="gray">以下为您最近10次登录记录，若存在异常情况，请在核实后尽快修改密码</span>
        </p>
        <el-table :data="tableData" style="width: 100%">
            <el-table-column label="登录时间">
                <template slot-scope="scope">
                    <i class="el-icon-time marginR5"></i>
                    {{ scope.row.createDate }}
                </template>
            </el-table-column>
            <el-table-column prop="ipAddress" label="IP地址"></el-table-column>
            <el-table-column label="浏览器">
                <template slot-scope="scope">
                    <img :src="getBrowserIcon(scope.row.browser)" class="browser-icon" alt="" />
                    {{ scope.row.browser }}
                </template>
            </el-table-column>
            <el-table-column prop="authType" label="验证方式"></el-table-column>
            <el-table-column show-overflow-tooltip prop="device" label="设备"></el-table-column>
            <el-table-column show-overflow-tooltip prop="city" label="地点"></el-table-column>
        </el-table>
        <p class="paddingB15 marginT60">
            <span class="fontBold">敏感操作记录</span>
            <span class="gray">以下为您账号的敏感操作记录，若存在异常操作，请核实后尽快修改密码等内容</span>
        </p>
        <el-table :data="tableData2" style="width: 100%">
            <el-table-column label="登录时间">
                <template slot-scope="scope">
                    <i class="el-icon-time marginR5"></i>
                    {{ scope.row.createDate }}
                </template>
            </el-table-column>
            <el-table-column prop="ipAddress" label="IP地址"></el-table-column>
            <el-table-column label="浏览器">
                <template slot-scope="scope">
                    <img :src="getBrowserIcon(scope.row.browser)" class="browser-icon" alt="" />
                    {{ scope.row.browser }}
                </template>
            </el-table-column>
            <el-table-column show-overflow-tooltip prop="device" label="设备"></el-table-column>
            <el-table-column show-overflow-tooltip prop="city" label="地点"></el-table-column>
            <el-table-column show-overflow-tooltip prop="operationRecord" label="操作纪录"></el-table-column>
        </el-table>
        <div class="page-pagination-wrapper text-right paddingT10">
            <el-pagination
                v-show="paginationTotal"
                :current-page.sync="searchData.current"
                :page-sizes="[10, 20, 30, 50, 100]"
                :page-size="searchData.size"
                layout="total, sizes, prev, pager, next"
                :total="paginationTotal"
                @size-change="handleSizeChange"
                @current-change="getSensitiveRecord"
            ></el-pagination>
        </div>
    </div>
</template>

<script>
export default {
    props: {
        username: {
            type: String,
            require: true,
        },
    },
    data() {
        return {
            get_data_api: "/user/personalCenter/landingHistory",
            get_data_api2: "/user/personalCenter/sensitiveRecord",
            tableData: [],
            tableData2: [],
            browser: {
                ie: require("../../../../common/images/browserIcon/ie.png"),
                chrome: require("../../../../common/images/browserIcon/chrome.png"),
                safari: require("../../../../common/images/browserIcon/safari.png"),
                firefox: require("../../../../common/images/browserIcon/firefox.png"),
            },
            searchData: {
                current: 1,
                size: 10,
            },
            paginationTotal: 0,
        };
    },
    created() {
        this.getData();
        this.getSensitiveRecord();
    },
    methods: {
        /**
         * 搜索
         */
        search() {
            this.searchFormData.current = 1;
            this.getSensitiveRecord();
        },
        /**
         * 每页显示条数改变后重新搜索
         */
        handleSizeChange(val) {
            this.searchFormData.size = val;
            this.search();
        },
        getData() {
            this.$axios.get(this.get_data_api, { userId: this.$store.state.user.userData.id }).then((res) => {
                if (res.body) {
                    this.tableData = res.body || [];
                }
            });
        },
        getSensitiveRecord() {
            this.$axios
                .get(this.get_data_api2, { userId: this.$store.state.user.userData.id, ...this.searchData })
                .then((res) => {
                    if (res.body) {
                        this.tableData2 = res.body.records || [];
                        this.paginationTotal = res.body.total;
                    }
                });
        },
        getBrowserIcon(str) {
            let key = "";
            if (str.toLowerCase().includes("explorer")) {
                key = "ie";
            } else if (str.toLowerCase().includes("chrome")) {
                key = "chrome";
            } else if (str.toLowerCase().includes("safari")) {
                key = "safari";
            } else if (str.toLowerCase().includes("firefox")) {
                key = "firefox";
            }
            return this.browser[key] || "";
        },
    },
};
</script>

<style scoped>
.browser-icon {
    display: inline-block;
    vertical-align: middle;
    width: 16px;
    height: 16px;
    margin-right: 4px;
}
</style>
